// extracted by mini-css-extract-plugin
module.exports = {"loader":"variant1_loader__u_F4Y","bblFadInOut":"variant1_bblFadInOut__u7Ans"};